<template>
  <div class="background" :style="backgroundStyle">
    <div v-if="videoPath">
      <video
        ref="video"
        id="fullscreenVideo"
        style="width: 100%"
        autoplay
        controls
      >
        <source :src="videoPath" type="video/mp4" />
      </video>
      <div id="videoBackOverlayBottomRight" style="z-index: 100">
        <img
          src="@/assets/ZURUECK.png"
          style="width: 7%"
          alt="Back Button"
          @click="exitVideo()"
        />
      </div>
    </div>
    <div v-else>
      <div v-for="video in videoInfos" :key="video.path">
        <!-- <div class="tile" :style="video.style" /> -->
        <div class="tile" :style="video.style" @click="playVideo(video)">
          <div style="margin: 10px; position: relative; top: 100%">
            {{ video.description }}
          </div>
        </div>
      </div>
      <div id="overlayBottomRight" style="z-index: 100">
        <img
          src="@/assets/ZURUECK.png"
          style="width: 7%"
          alt="Back Button"
          @click="backClicked()"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { videoPageSettings } from "../VideoPageSettings";

export default {
  name: "VideoPage",
  data() {
    return {
      // videoPath: videoPageSettings[this.$route.params.page].videoPath,
      videoInfos: videoPageSettings[this.$route.params.page].videos,
      backDestinationName:
        videoPageSettings[this.$route.params.page].backDestinationName,
      backDestinationParam:
        videoPageSettings[this.$route.params.page].backDestinationParam,

      videoPath: "",

      backgroundStyle: {
        backgroundImage: `url(${require("@/assets/LR-videostartseite.jpg")})`,
      },
    };
  },
  methods: {
    backClicked() {
      this.$router.push({
        name: this.backDestinationName,
        params: { page: this.backDestinationParam },
      });
    },
    playVideo(video) {
      this.videoPath = video.path;
      const that = this;
      setTimeout(function () {
        that.$refs.video.volume = 0.5;
      }, 200);

      if (
        !this.videoPath.startsWith("https://") &&
        !this.videoPath.startsWith("http://")
      ) {
        this.videoPath = "https://my.lrinfomanager.com/" + this.videoPath;
      }
    },
    exitVideo() {
      this.videoPath = "";
    },
  },
  created() {
    // if (
    //   !this.videoPath.startsWith("https://") &&
    //   !this.videoPath.startsWith("http://")
    // ) {
    //   this.videoPath = "https://my.lrinfomanager.com/" + this.videoPath;
    // }
  },
};
</script>

<style scoped>
.background {
  width: 100%;
  height: 100%;
  background-size: contain;
}

.tile {
  position: absolute;
  width: 16.6%;
  height: 17%;
  background-size: contain;
  text-align: center;
  display: table-cell;
  vertical-align: middle;
  font-size: 12pt;
  font-family: Calibri;
}

@media (max-width: 1000px) {
  .tile {
    font-size: 8pt;
  }
}

#overlayBottomRight {
  position: absolute;
  bottom: 2%;
  /* background: rgba(0, 0, 0, 0.5); */
  width: 100%;
  right: 2%;
  text-align: right;
  z-index: 1000;
}

#videoBackOverlayBottomRight {
  position: absolute;
  bottom: 10%;
  /* background: rgba(0, 0, 0, 0.5); */
  width: 100%;
  right: 2%;
  text-align: right;
  z-index: 1000;
}

@media (max-height: 500px) {
  #videoBackOverlayBottomRight {
    bottom: 20%;
  }
}

@media (max-width: 800px) {
  #videoBackOverlayBottomRight {
    bottom: 20%;
  }
}

#overlayBottomRightInfo {
  position: absolute;
  bottom: 2%;
  /* background: rgba(0, 0, 0, 0.5); */
  width: 90%;
  /* padding: 30px; */
  text-align: right;
}
</style>